export const LOAD_FOLDER_GENERAL_INFO_STARTED = "LOAD_FOLDER_GENERAL_INFO_STARTED";
export const LOAD_FOLDER_GENERAL_INFO_SUCCESS = "LOAD_FOLDER_GENERAL_INFO_SUCCESS";
